import { Box } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled(Box)`
  width: auto;
`;
